import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eos-not-found',
  template: `
  <div class="row">
  <div class="col pb-5">
    <h6><strong>Not found</strong></h6>
  </div>
</div>
<div class="row">
  <div class="col-md-1">

  </div>
  <div class="col-md">
    <img src="design/images/Forbidden.png" class="forb-img" />
    <h1>OOPSSS!!!! Sorry...</h1>
    <p>Sorry, The page/content you requested can not be found!</p>
    <a routerLink="/home"><button class="btn btn-secondary mb-5">Home</button></a>
  </div>
</div>
      `,
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
